import Ajax from 'models/ajax-api'

class SearchCarType

  URL: '/sky/'
  mobileURL: '/s/AR000.php'
  activeClass: 'is-active'
  disabledClass: 'is-disabled'

  constructor: (@$elm, @$value, @mobile = false) ->
    @$window      = $ window
    @$cartypeBox  = $ '.js-cartype-box'
    @$cartypelist = @$cartypeBox.find '.js-cartype-list'
    @$narrows     = @$cartypeBox.find '.js-narrow-select'
    @$cartype     = @$cartypelist.children()
    @$narrow      = @$narrows.find 'input'
    @$modal       = $ '[data-remodal-id=remodal-cartype]'
    @modal        = @$modal.remodal()
    @ajax         = new Ajax

    @$elm.on 'click', @open
    @$cartype.on 'click', @carClick
    @$narrow.on 'change', @narrowChange
    @$modal.on 'confirmation', @modalSubmitClick

    @ajax.run
      # 本番
      url: '/json/office-car.json'
    .then (data) =>
      @carData = data
      @haveCar()
      @$window.on 'changeArea', @haveCar

  modalSubmitClick: (event) =>
    { $elm } = @
    @elm =@$elm.parent().parent().parent()
    event.preventDefault()
    $data = @elm.find 'input, select'
    data  = {}
    _.forEach $data, (_elm) ->
      return true unless _elm.name
      if _elm.name is 'car'
        data[_elm.name] = unless data[_elm.name]
          _elm.value
        else
          data[_elm.name] + ',' + _elm.value
      else
        data[_elm.name] = _elm.value.replace /:/g , '-'

    data.go          = '-' unless data.go
    data.return      = '-' unless data.return
    data.area2       = '0' unless data.area2
    data.area3       = '0' unless data.area3
    data.go_time     = '-' unless data.go_time
    data.return_time = '-' unless data.return_time
    data.car         = ',' unless data.car
    data.narrow      = ',' unless data.narrow

    @transition data

  transition: (data) ->
    { mobile, mobileURL, URL } = @
    url = if mobile
      "#{URL}searches/car_class/00/03/#{data.area1}/#{data.area2}/#{data.go}/#{data.return}/#{data.go_time}/#{data.return_time}/#{data.car}/#{data.narrow}/#{data.area3}"
    else
      "#{URL}searches/car_class/00/03/#{data.area1}/#{data.area2}/#{data.go}/#{data.return}/#{data.go_time}/#{data.return_time}/#{data.car}/#{data.narrow}/#{data.area3}"
    location.href = url

  open: (event) =>
    @selectElm = event.currentTarget
    @modal.open()

  carClick: (event) =>
    elm = event.currentTarget
    return true if elm.classList.contains @disabledClass
    elm.classList.toggle @activeClass
    @check()

  narrowChange: (event) =>
    elm = event.currentTarget
    $checkOff = @$narrow.filter (i, _elm) ->
      elm isnt _elm
    $checkOff.prop 'checked', false
    @narrowInput = if elm.checked
      "<input type=\"hidden\" name=\"#{elm.name}\" value=\"#{elm.value}\">"
    else
      null
    @check()

  narrowCheck: =>
    $elm = @$narrow.filter ':checked'
    elm = $elm[0]
    @narrowInput = if $elm.length
      "<input type=\"hidden\" name=\"#{elm.name}\" value=\"#{elm.value}\">"
    else
      null

  check: =>
    activeArr = []
    activeTitleArr = []
    _.forEach @$cartype, (elm) =>
      return true unless elm.classList.contains @activeClass
      $elm = $ elm
      title = $elm.data 'title'
      value = $elm.data 'value'
      activeTitleArr.push title
      input = "<input type=\"hidden\" name=\"car\" value=\"#{value}\">"
      activeArr.push input
    if @narrowInput
      activeArr.push @narrowInput
    activeTitle = if activeTitleArr.length then activeTitleArr else '選択してください'
    @$elm.val activeTitle
    @$value.html activeArr.join ''

  init: =>
    @check()

  haveCar: =>
    officeID = Number document.getElementsByName('area3')[0].value
    arr = _.filter @carData,
      office: officeID
    if arr.length
      _.forEach @$cartype, (_elm) =>
        $_elm = $ _elm
        typeID = Number $_elm.data 'value'
        unless arr[0].car.indexOf(typeID) is -1
          _elm.classList.add @disabledClass
          _elm.classList.remove @activeClass
        else
          _elm.classList.remove @disabledClass
      _.forEach @$narrow, (_elm) =>
        $_elm    = $ _elm
        $_parent = $_elm.parents 'li'
        value    = Number _elm.value
        unless arr[0].narrow
          arr[0].narrow = ''
        unless arr[0].narrow.indexOf(value) is -1
          $_parent.addClass @disabledClass
          $_elm.prop
            'checked': false
            'disabled': true
        else
          $_elm.prop
            'disabled': false
          $_parent.removeClass @disabledClass
      @narrowCheck()
      @check()
    else
      _.forEach @$cartype, (_elm) =>
        _elm.classList.remove @disabledClass
      _.forEach @$narrow, (_elm) =>
        $_elm = $ _elm
        $_parent = $_elm.parents 'li'
        $_elm.prop
          'disabled': false
        $_parent.removeClass @disabledClass

export default SearchCarType



// WEBPACK FOOTER //
// ./webpack/imports/view/search-cartype.coffee